import React, { Component } from "react"
import Query from "../../../components/Query"
import Card from "../../../components/Card"
import DateRange from "../../../components/DateRange"
import SimpleLoader from "../../../components/SimpleLoader"
import { withActions } from "../../../utils"
import _ from "lodash"
import styles from "./styles.css"
import DebtPhasesTable from "../DebtPhasesTable"


class PickDebtPhases extends Component {
  props: {
    value: any,
    onChange: any,

    actions: false,
  }

  buildQueryArgs = () => _.pick(
    _.get( this.props, "value", {} ),
    [
      "billingPhase", "debtPhase", "clientName",
      "segment", "expenseDateStart", "expenseDateEnd",
    ]
  )

  renderNoResults () {
    return (
      <div className={styles.noInvoices}>
        Sem resultados
      </div>
    )
  }

  selectDebtPhases = debtPhases => this.props.onChange( {
    ...this.props.value,
    debtPhases,
  } )

  render () {
    return (
      <Card className={styles.card}>
        <div className={styles.toolbar}>
          <DateRange
            label="Data de despesa"
            onChange={newValue => this.props.onChange( {
              ...this.props.value,
              expenseDateStart: _.get( newValue, "from" ),
              expenseDateEnd: _.get( newValue, "to" ),
            } )}
            value={{
              from: _.get( this.props, "value.expenseDateStart" ),
              to: _.get( this.props, "value.expenseDateEnd" ),
            }}
          />
        </div>
        <Query
          allEvents
          query={this.props.actions.searchDebtPhasesByExpense}
          args={this.buildQueryArgs()}
        >
          {( { response, loading, error } ) => {
            const args = this.buildQueryArgs()
            if ( !args.expenseDateStart && !args.expenseDateEnd ) {
              return null
            }

            if ( loading ) {
              return <SimpleLoader />
            }

            if ( error ) {
              return <div>Erro</div>
            }

            if ( response.length === 0 ) {
              return this.renderNoResults()
            } else {
              return (
                <DebtPhasesTable
                  debtPhases={response}
                  selectedDebtPhases={_.get( this.props, "value.debtPhases", [] )}
                  onSelect={this.selectDebtPhases}
                />
              )
            }
          }}
        </Query>
      </Card>
    )
  }
}

export default withActions( PickDebtPhases )



// WEBPACK FOOTER //
// ./src/views/CreateBillingOrder/PickDebtPhases/index.jsx